/* DashOTB Depth: one shared player with a site-wide play bar, peak waveforms, the bag drawer, the archive slide, shelf filters. No dependencies. */
(function () {
  'use strict';
  var d = document, A = d.getElementById('dp-audio'), bar = d.getElementById('dp-bar');
  if (!A || !bar) return;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var fmt = function (s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); };
  var NS = 'http://www.w3.org/2000/svg', KEY = 'dp-player';
  var Q = [], qi = -1, cur = null, raf = 0, seekTo = null, lastSave = 0;
  var bwave = $('svg.wC', bar);

  /* ---------- peaks and waveforms ---------- */
  function cached(src) { try { var c = JSON.parse(localStorage.getItem('dpk2:' + src)); return c && c.p ? c : null; } catch (e) { return null; } }
  function parsePk(el) {
    var raw = el.getAttribute('data-pk'), pk = null;
    if (raw) { try { pk = JSON.parse(raw); } catch (e) {} }
    el._pk = pk && pk.p ? pk : cached(el.dataset.src);
  }
  /* Waveform v2 (18 Oct): thin rounded bars (2px, 1.5px gap, sized to the real pixel width so they stay crisp),
     an RMS-smoothed shape, a coral gradient on the played part, a glowing playhead and a live shimmer behind it. */
  var PITCH = 3.5, ro2 = window.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (en) { var sv = en.target, W = en.contentRect.width; if (W && Math.abs(W - (sv._W || 0)) > 4) { draw(sv, sv._pk); if (cur) tick(true); } }); }) : null;
  function shape(p, m) {
    // resample to m bars (RMS of each span), smooth [1 2 1], scale from a low floor to the peak, gamma 1.1
    var n = p.length, o = [], i, j, a, b, s, c;
    for (i = 0; i < m; i++) { a = Math.floor(i * n / m); b = Math.max(a + 1, Math.ceil((i + 1) * n / m)); s = 0; c = 0; for (j = a; j < b; j++) { var v = p[Math.min(n - 1, j)] || 0; s += v * v; c++; } o.push(Math.sqrt(s / c)); }
    var sm = o.map(function (v, i) { return ((i ? o[i - 1] : v) + 2 * v + (i < m - 1 ? o[i + 1] : v)) / 4; });
    var srt = sm.slice().sort(function (x, y) { return x - y; }), lo = srt[Math.floor(m * 0.04)] * 0.6, hi = srt[m - 1] || 1;
    return sm.map(function (v) { var q = Math.max(0, Math.min(1, (v - lo) / ((hi - lo) || 1))); return 0.05 + 0.95 * Math.pow(q, 1.1); });
  }
  function el(n, a) { var e = d.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }
  var defsOn = false;
  function defs() {
    if (defsOn) return; defsOn = true;
    var g = el('svg', { width: 0, height: 0, 'aria-hidden': 'true', focusable: 'false' }); g.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    g.innerHTML = '<defs><linearGradient id="dp-wg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffd9c6"/><stop offset=".5" stop-color="#ec8a63"/><stop offset="1" stop-color="#ffd9c6"/></linearGradient></defs>';
    d.body.appendChild(g);
  }
  function draw(svg, pk) {
    defs();
    var w = +svg.dataset.w, h = +svg.dataset.h, m = h / 2, W = svg.getBoundingClientRect().width || w, dd = '';
    svg._pk = pk; svg._W = W; svg._g = null;
    if (ro2 && !svg._ro) { svg._ro = 1; ro2.observe(svg); }
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (pk) {
      var nb = Math.max(16, Math.floor(W / PITCH)), q = shape(pk.p, nb);
      for (var i = 0; i < nb; i++) { var x = ((i + 0.5) * w / nb).toFixed(2), dy = Math.max(0.5, q[i] * (m - 1.5)); dd += 'M' + x + ' ' + (m - dy).toFixed(2) + 'V' + (m + dy).toFixed(2); }
      svg._g = { nb: nb, q: q, m: m, w: w };
    } else dd = 'M1 ' + m + 'H' + (w - 1);
    svg.appendChild(el('path', { 'class': 'fu', d: dd }));
    svg.appendChild(el('path', { 'class': 'fp', d: dd }));
    svg.appendChild(el('path', { 'class': 'lv', d: '' }));
    svg.appendChild(el('line', { 'class': 'pg', x1: 0, y1: 2, x2: 0, y2: h - 2 }));
    svg.appendChild(el('line', { 'class': 'ph', x1: 0, y1: 0, x2: 0, y2: h }));
    svg.appendChild(el('line', { 'class': 'gh', x1: 0, y1: 0, x2: 0, y2: h }));
  }
  // live level behind the playhead: the Web Audio analyser on desktop (the CDN sends CORS headers); a gentle pulse from the peaks elsewhere.
  // shortcut: phones skip Web Audio because routing audio through it stops lock-screen/background playback on iOS; revisit if that changes.
  var fine = matchMedia('(pointer: fine)').matches && !/iPad|iPhone|iPod/.test(navigator.userAgent), AN = null, ACX = null, abuf = null;
  if (fine && !RM) A.crossOrigin = 'anonymous';
  function analyser() {
    if (AN || ACX || !fine || RM) { if (ACX && ACX.state === 'suspended') ACX.resume(); return; }
    if (navigator.userActivation && !navigator.userActivation.isActive) return; // only from a real tap/click, or the context would start suspended and mute the audio
    try { var C = window.AudioContext || window.webkitAudioContext; ACX = new C(); var src = ACX.createMediaElementSource(A); src.connect(ACX.destination); AN = ACX.createAnalyser(); AN.fftSize = 256; AN.smoothingTimeConstant = 0.7; src.connect(AN); abuf = new Uint8Array(AN.frequencyBinCount); } catch (e) { AN = null; }
  }
  function shimmer(svgs, p) {
    var t = performance.now(), L = 0, i;
    if (AN) { AN.getByteFrequencyData(abuf); for (i = 0; i < abuf.length; i++) L += abuf[i]; L = Math.min(1, L / abuf.length / 100); }
    svgs.forEach(function (s) {
      var g = s._g, lv = s.lastChild && s.querySelector('.lv'); if (!g || !lv) return;
      var c = Math.min(g.nb - 1, Math.floor(p * g.nb)), lvl = AN ? L : g.q[c] * (0.6 + 0.4 * Math.sin(t / 150)), dd = '';
      for (var j = Math.max(0, c - 6); j <= c; j++) {
        var k = 1 - (c - j) / 7, wob = 0.5 + 0.5 * Math.sin(t / 80 + j * 1.9), dy = Math.min(g.m - 1, g.q[j] * (g.m - 1.5) * (1 + 0.6 * k * lvl * wob));
        dd += 'M' + ((j + 0.5) * g.w / g.nb).toFixed(2) + ' ' + (g.m - dy).toFixed(2) + 'V' + (g.m + dy).toFixed(2);
      }
      lv.setAttribute('d', dd); lv.style.opacity = (0.35 + 0.65 * Math.min(1, lvl * 1.4)).toFixed(2);
    });
  }
  function grow(svgs) {
    if (RM) return;
    svgs.forEach(function (s) { s.classList.remove('grow'); void s.getBoundingClientRect(); s.classList.add('grow'); clearTimeout(s._gt); s._gt = setTimeout(function () { s.classList.remove('grow'); }, 800); });
  }
  function paint(it) {
    var D = it._pk && it._pk.d || 0;
    $$('svg.wC', it).forEach(function (s) { draw(s, it._pk); s.setAttribute('aria-valuemax', Math.round(D)); });
    $$('[data-du]', it).forEach(function (e) { e.textContent = D ? fmt(D) : ''; });
  }
  function initItem(it) {
    if (it._ok) return; it._ok = 1;
    var pl = $('script[data-pl]', it);
    if (pl) { try { it._pl = JSON.parse(pl.textContent); it._i = 0; } catch (e) {} }
    parsePk(it); paint(it);
  }
  /* A cover player / archive caption walks a list: point it at entry i. */
  function setIndex(it, i, quiet) {
    var s = it._pl[i]; if (!s) return;
    it._i = i; it.dataset.src = s.u; it.dataset.t = s.t;
    ['k', 'ku', 'a', 'v', 'p', 'cp'].forEach(function (f) { if (s[f] != null) it.dataset[f] = s[f]; });
    it._pk = s.pk && s.pk.p ? s.pk : cached(s.u);
    var ti = $('[data-ti]', it); if (ti) ti.textContent = s.t;
    var ix = $('[data-ix]', it); if (ix) ix.textContent = (i + 1) + ' of ' + it._pl.length;
    paint(it);
    if (!quiet && it._onidx) it._onidx(i);
  }

  /* ---------- tracks and the queue ---------- */
  function track(it, s) {
    var img = $('[data-tg] img', it), t = { src: it.dataset.src, t: it.dataset.t, k: it.dataset.k || '', ku: it.dataset.ku || '', a: it.dataset.a || (img && img.currentSrc) || '', v: it.dataset.v || '', p: it.dataset.p || '', cp: it.dataset.cp || '', pk: it._pk };
    if (s) { t.src = s.u; t.t = s.t; t.pk = s.pk && s.pk.p ? s.pk : cached(s.u); ['k', 'ku', 'a', 'v', 'p', 'cp'].forEach(function (f) { if (s[f] != null) t[f] = s[f]; }); }
    return t;
  }
  function queueFrom(it) {
    initItem(it);
    if (it._pl) return { q: it._pl.map(function (s) { return track(it, s); }), i: it._i };
    var box = it.closest('.lstC,.gA,.gS'), els = box ? $$('.dp-it', box).filter(function (x) { return x.dataset.src; }) : [it];
    return { q: els.map(function (x) { initItem(x); return track(x); }), i: Math.max(0, els.indexOf(it)) };
  }
  function isCur(it) { return !!cur && it.dataset.src === cur.src; }
  function playAt(i, at) {
    if (!Q[i]) return;
    qi = i; cur = Q[i]; seekTo = at == null ? null : at;
    analyser(); A.src = cur.src; var p = A.play(); if (p && p.catch) p.catch(function () {});
    fillBar(); sync(); save(true);
    grow($$('.dp-it.cur svg.wC').concat([bwave]));
  }
  function resume() {
    if (!cur) return;
    analyser(); if (A.getAttribute('src') !== cur.src) { A.src = cur.src; }
    var p = A.play(); if (p && p.catch) p.catch(function () {});
  }
  function toggle(it) {
    if (isCur(it)) { if (A.paused) resume(); else A.pause(); return; }
    var r = queueFrom(it); Q = r.q; playAt(r.i);
  }
  function stop() {
    A.pause(); A.removeAttribute('src'); cur = null; Q = []; qi = -1;
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    bar.classList.remove('show', 'on'); d.body.classList.remove('has-bar');
    setTimeout(function () { if (!cur) bar.hidden = true; }, 320);
    sync();
  }
  /* Mirror the player onto every element on the page (rows, tiles, covers, the archive caption). */
  function sync() {
    var playing = !!cur && !A.paused;
    $$('.dp-it').forEach(function (it) {
      initItem(it);
      if (cur && it._pl && it.dataset.src !== cur.src) { for (var k = 0; k < it._pl.length; k++) if (it._pl[k].u === cur.src) { setIndex(it, k); break; } }
      var c = isCur(it), was = it.classList.contains('cur');
      it.classList.toggle('cur', c); it.classList.toggle('on', c && playing);
      if (it.classList.contains('tA')) it.classList.toggle('big', c);
      $$('[data-tg]', it).forEach(function (b) { b.setAttribute('aria-label', (c && playing ? 'Pause ' : 'Play ') + (it.dataset.t || '')); });
      $$('svg.wC', it).forEach(function (s) { s.tabIndex = c ? 0 : -1; });
      if (was && !c) { $$('svg.wC', it).forEach(function (s) { setProg(s, 0); }); $$('[data-el]', it).forEach(function (e) { e.textContent = '0:00'; }); }
    });
    bar.classList.toggle('on', playing);
    $('[data-bplay]', bar).setAttribute('aria-label', playing ? 'Pause' : 'Play');
    $('[data-bprev]', bar).disabled = !cur;
    $('[data-bnext]', bar).disabled = !cur || qi >= Q.length - 1;
    tick(true);
  }
  function setProg(s, p) {
    var f = $('.fp', s), w = +s.dataset.w;
    if (f) f.style.clipPath = 'inset(0 ' + (100 - p * 100).toFixed(2) + '% 0 0)';
    $$('.ph,.pg', s).forEach(function (l) { l.setAttribute('x1', p * w); l.setAttribute('x2', p * w); });
  }
  function dur() { return (isFinite(A.duration) && A.duration) || (cur && cur.pk && cur.pk.d) || 0; }
  function now() { return A.getAttribute('src') ? A.currentTime : (seekTo || 0); }
  function tick(once) {
    if (!cur) return;
    var D = dur(), t = now(), p = D ? Math.min(1, t / D) : 0, live = $$('.dp-it.cur').concat([bar]);
    live.forEach(function (it) {
      $$('svg.wC', it).forEach(function (s) { setProg(s, p); s.setAttribute('aria-valuenow', Math.round(t)); s.setAttribute('aria-valuetext', fmt(t) + ' of ' + fmt(D)); });
      $$('[data-el]', it).forEach(function (e) { e.textContent = fmt(t); });
    });
    bar.style.setProperty('--pp', (p * 100).toFixed(1) + '%');
    var lsv = []; live.forEach(function (it) { lsv = lsv.concat($$('svg.wC', it)); });
    if (!A.paused && !RM && A.getAttribute('src')) shimmer(lsv, p); else $$('.wC .lv').forEach(function (l) { l.setAttribute('d', ''); });
    if (!once && !A.paused) { save(); raf = requestAnimationFrame(function () { tick(); }); }
  }

  /* ---------- the play bar ---------- */
  function fillBar() {
    if (!cur) return;
    bar.hidden = false; requestAnimationFrame(function () { bar.classList.add('show'); });
    d.body.classList.add('has-bar');
    var img = $('.pb-art img', bar); if (cur.a) img.src = cur.a;
    $('[data-bt]', bar).textContent = cur.t;
    var k = $('[data-bk]', bar), k2 = $('[data-bk2]', bar), here = cur.ku && location.pathname.replace(/\/$/, '') === cur.ku.replace(/\/$/, '');
    if (cur.ku && !here) { k.hidden = false; k.href = cur.ku; k.firstChild.textContent = 'From ' + cur.k + ' '; k2.hidden = true; }
    else { k.hidden = true; k2.hidden = false; k2.textContent = cur.k; }
    var ad = $('[data-badd]', bar); ad.hidden = !cur.v; ad.classList.remove('done');
    ad.innerHTML = 'Add&nbsp;·&nbsp;<span class="k-num">' + (cur.cp ? '<s><span class="sr">Was </span>' + esc(cur.cp) + '</s> ' : '') + esc(cur.p) + '</span>';
    draw(bwave, cur.pk); bwave.setAttribute('aria-label', 'Seek ' + cur.t);
    $('[data-du]', bar).textContent = dur() ? fmt(dur()) : '';
    session();
  }
  function save(force) {
    var t = Date.now(); if (!force && t - lastSave < 1500) return; lastSave = t;
    if (!cur) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ q: Q, i: qi, t: now() })); } catch (e) {}
  }
  addEventListener('pagehide', function () { save(true); });
  function restore() {
    var s; try { s = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) {}
    if (!s || !s.q || !s.q[s.i]) return;
    Q = s.q; qi = s.i; cur = Q[qi]; seekTo = s.t || 0;
    fillBar(); sync(); // browsers block auto-resume after a page load: one tap on play carries on from here
  }

  A.addEventListener('loadedmetadata', function () { if (seekTo) { A.currentTime = Math.min(seekTo, A.duration - 0.5); seekTo = null; } $('[data-du]', bar).textContent = fmt(A.duration); $$('.dp-it.cur [data-du]').forEach(function (e) { e.textContent = fmt(A.duration); }); });
  A.addEventListener('play', function () { if (ACX && ACX.state === 'suspended') ACX.resume(); cancelAnimationFrame(raf); sync(); tick(); if (window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.track) try { ShopifyAnalytics.lib.track('preview_play', { sound: cur && cur.t }); } catch (e) {} });
  A.addEventListener('playing', function () { learnPeaks(); });
  A.addEventListener('pause', function () { cancelAnimationFrame(raf); sync(); save(true); });
  A.addEventListener('ended', function () { if (qi < Q.length - 1) playAt(qi + 1); else { A.currentTime = 0; sync(); } });
  function skip(k) {
    if (!cur) return;
    if (k < 0 && now() > 3) { if (A.getAttribute('src')) A.currentTime = 0; else seekTo = 0; tick(true); return; }
    var i = qi + k; if (i < 0 || i >= Q.length) return; playAt(i);
  }

  function learnPeaks() {
    var t = cur; if (!t || t.pk || t._learn || !window.fetch) return; t._learn = 1;
    var C = window.AudioContext || window.webkitAudioContext; if (!C) return;
    fetch(t.src).then(function (r) { return r.arrayBuffer(); }).then(function (b) {
      var ctx = new C(); return new Promise(function (ok, no) { ctx.decodeAudioData(b, ok, no); }).then(function (buf) { ctx.close && ctx.close(); return buf; });
    }).then(function (buf) {
      var ch = buf.getChannelData(0), N = 240, L = ch.length, i, j, s2, c2, mx = [];
      for (i = 0; i < N; i++) { s2 = 0; c2 = 0; for (j = Math.floor(i * L / N); j < Math.floor((i + 1) * L / N); j += 4) { s2 += ch[j] * ch[j]; c2++; } mx.push(Math.sqrt(s2 / (c2 || 1))); }
      var srt = mx.slice().sort(function (a, b) { return a - b; }), p99 = srt[Math.floor(N * 0.99)] || 1;
      var pk = { v: 2, n: N, d: Math.round(buf.duration * 10) / 10, p: mx.map(function (v) { return Math.round(Math.min(1, v / p99) * 100); }) };
      try { localStorage.setItem('dpk2:' + t.src, JSON.stringify(pk)); } catch (e) {}
      t.pk = pk; $$('.dp-it').forEach(function (x) { if (x.dataset.src === t.src) { x._pk = pk; paint(x); } });
      if (cur === t) { draw(bwave, pk); tick(true); grow($$('.dp-it.cur svg.wC').concat([bwave])); }
    }).catch(function () {});
  }

  /* ---------- seeking on any waveform ---------- */
  d.addEventListener('pointerdown', function (e) {
    var s = e.target.closest && e.target.closest('svg.wC'); if (!s) return;
    var it = bar.contains(s) ? null : s.closest('.dp-it'); if (!it && !bar.contains(s)) return; if (bar.contains(s) && !cur) return;
    var r = s.getBoundingClientRect(), w = +s.dataset.w, g = $('.gh', s);
    var at = function (ev) { return Math.max(0, Math.min(1, (ev.clientX - r.left) / r.width)); };
    var mv = function (ev) { s.classList.add('scrub'); if (g) { g.setAttribute('x1', at(ev) * w); g.setAttribute('x2', at(ev) * w); } };
    var up = function (ev) {
      s.classList.remove('scrub'); d.removeEventListener('pointermove', mv); d.removeEventListener('pointerup', up);
      var f = at(ev);
      if (!it || isCur(it)) { var D = dur(); if (A.getAttribute('src') === cur.src && A.readyState > 0) { A.currentTime = f * D; if (A.paused) resume(); } else { seekTo = f * D; resume(); } tick(true); }
      else { var q = queueFrom(it); Q = q.q; playAt(q.i, f * ((it._pk && it._pk.d) || 0)); }
    };
    mv(e); d.addEventListener('pointermove', mv); d.addEventListener('pointerup', up); e.preventDefault();
  });
  // hover: a preview line and the time under the cursor (mouse only)
  var tip = null, hovS = null;
  d.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    var s = e.target.closest && e.target.closest('svg.wC'), it = s && !bar.contains(s) ? s.closest('.dp-it') : null;
    if (s && !it && !bar.contains(s)) s = null;
    if (hovS && hovS !== s) { hovS.classList.remove('hov'); if (tip) tip.hidden = true; hovS = null; }
    if (!s || s.classList.contains('scrub')) return;
    hovS = s; s.classList.add('hov');
    var r = s.getBoundingClientRect(), f = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)), w = +s.dataset.w, g = $('.gh', s);
    if (g) { g.setAttribute('x1', f * w); g.setAttribute('x2', f * w); }
    var D = (!it || isCur(it)) ? dur() : ((it._pk && it._pk.d) || 0);
    if (!tip) { tip = d.createElement('div'); tip.className = 'wtip'; tip.setAttribute('aria-hidden', 'true'); ($('.dp-x') || d.body).appendChild(tip); }
    tip.hidden = !D; tip.textContent = fmt(f * D);
    tip.style.transform = 'translate(' + Math.round(e.clientX) + 'px,' + Math.round(r.top - 30) + 'px) translateX(-50%)';
  }, { passive: true });
  d.addEventListener('keydown', function (e) {
    var s = e.target.closest && e.target.closest('svg.wC');
    if (s && cur && A.getAttribute('src')) {
      var D = dur(), t = A.currentTime, k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowUp') t += 5; else if (k === 'ArrowLeft' || k === 'ArrowDown') t -= 5; else if (k === 'Home') t = 0; else if (k === 'End') t = D - 0.2; else return;
      A.currentTime = Math.max(0, Math.min(D, t)); tick(true); e.preventDefault(); return;
    }
    if (e.key === 'Escape' && d.documentElement.classList.contains('bag-open')) bag(false);
    if (e.key === 'Escape' && sheet && !sheet.hidden) menu(false);
  });

  /* the loop subscription's "Send my loops by": the number box only for iMessage */
  d.addEventListener('change', function (e) {
    var sb = e.target.name === 'sendby' && e.target.closest('[data-sendby]'); if (!sb) return;
    var im = e.target.value === 'iMessage';
    $('[data-sb-phone]', sb).hidden = !im; $('[data-sb-email]', sb).hidden = im; $('[data-sb-err]', sb).hidden = true;
  });

  /* ---------- clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode, b;
    if ((b = t.closest('[data-bplay]'))) { e.preventDefault(); if (cur) { if (A.paused) resume(); else A.pause(); } return; }
    if ((b = t.closest('[data-bprev]'))) { e.preventDefault(); skip(-1); return; }
    if ((b = t.closest('[data-bnext]'))) { e.preventDefault(); skip(1); return; }
    if ((b = t.closest('[data-bx]'))) { e.preventDefault(); stop(); return; }
    if ((b = t.closest('[data-badd]'))) { e.preventDefault(); if (cur && cur.v) add(cur.v, b); return; }
    if ((b = t.closest('[data-tg]'))) { var it = b.closest('.dp-it'); if (it) { e.preventDefault(); toggle(it); } return; }
    if ((b = t.closest('[data-nx]'))) {
      e.preventDefault(); var c = b.closest('.dp-it'); initItem(c); var n = c._pl.length, i = (c._i + +b.dataset.nx + n) % n;
      if (isCur(c)) { var r = queueFrom(c); Q = r.q; playAt(i); } else setIndex(c, i);
      return;
    }
    if ((b = t.closest('[data-add]'))) { e.preventDefault(); add(b.dataset.add, b, b.dataset.sp); return; }
    if ((b = t.closest('[data-xs]'))) { e.preventDefault(); var row = b.closest('.sC,.tA'); var on = !row.classList.contains('xsel'); row.classList.toggle('xsel', on); $$('[data-xs]', row).forEach(function (x) { x.classList.toggle('sel', on); x.setAttribute('aria-expanded', on); }); return; }
    if ((b = t.closest('[data-mnu]'))) { e.preventDefault(); menu(sheet.hidden); return; }
    if ((b = t.closest('[data-bago]'))) { e.preventDefault(); menu(false); bag(true); return; }
    if (sheet && !sheet.hidden && t.closest('.msheet a')) menu(false);
    if ((b = t.closest('[data-bagx]'))) { e.preventDefault(); bag(false); return; }
    if ((b = t.closest('[data-rm]'))) { e.preventDefault(); cartPost('/cart/change.js', { id: b.dataset.rm, quantity: 0 }).then(renderBag); return; }
    if ((b = t.closest('[data-copy]'))) { e.preventDefault(); var code = b.dataset.copy, done = function () { var o = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = o; }, 2000); }; if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done(); return; }
  });
  // on phones the keyboard would push the bar over the email field: step it aside while typing
  var phone = matchMedia('(max-width: 700px)');
  d.addEventListener('focusin', function (e) { if (phone.matches && e.target.matches('input,textarea,select')) bar.classList.add('kb'); });
  d.addEventListener('focusout', function (e) { if (e.target.matches('input,textarea,select')) bar.classList.remove('kb'); });
  function session() {
    if (!('mediaSession' in navigator) || !cur) return;
    try {
      navigator.mediaSession.metadata = new MediaMetadata({ title: cur.t, artist: 'dashotb', album: cur.k || '', artwork: cur.a ? [{ src: cur.a, sizes: '192x192' }] : [] });
      navigator.mediaSession.setActionHandler('play', resume);
      navigator.mediaSession.setActionHandler('pause', function () { A.pause(); });
      navigator.mediaSession.setActionHandler('seekto', function (e) { A.currentTime = e.seekTime; tick(true); });
      navigator.mediaSession.setActionHandler('previoustrack', function () { skip(-1); });
      navigator.mediaSession.setActionHandler('nexttrack', function () { skip(1); });
    } catch (e) {}
  }

  /* ---------- the bag ---------- */
  var money = function (c) { var f = (window.dpCfg && dpCfg.money) || '${{amount}}', v = (c / 100).toFixed(2); var s = f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) { return k.indexOf('no_decimals') > -1 ? Math.round(c / 100) : (k.indexOf('comma') > -1 ? v.replace('.', ',') : v); }); return s.replace(/\.00(?!\d)/, ''); };
  function cartPost(u, body) { return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  function count(n) { $$('[data-bagn]').forEach(function (e) { e.innerHTML = '&nbsp;' + n; }); }
  function markAdded(id) {
    $$('button.ad[data-add="' + id + '"]').forEach(function (b) { var s = d.createElement('span'); s.className = 'added'; s.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.4 8.4 6.5 11.3 12.6 4.9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>Added'; b.replaceWith(s); });
    if (cur && cur.v == id) { var a = $('[data-badd]', bar); a.textContent = 'Added'; a.classList.add('done'); }
  }
  function add(id, b, sp) {
    if (!id) return; if (b) b.disabled = true;
    var item = { id: +id, quantity: 1 }; if (sp) item.selling_plan = +sp;
    var sb = b && b.closest('.pd-tx') && $('[data-sendby]', b.closest('.pd-tx'));
    if (sb) {   // the loop subscription: how to send the loops goes onto the order
      var how = ($('input[name=sendby]:checked', sb) || {}).value || 'iMessage', ph = $('#sb-phone', sb).value.trim(), err = $('[data-sb-err]', sb);
      if (how === 'iMessage' && ph.replace(/\D/g, '').length < 8) { err.hidden = false; $('#sb-phone', sb).focus(); if (b) b.disabled = false; return; }
      err.hidden = true;
      item.properties = how === 'iMessage' ? { 'Send by': 'iMessage', 'iMessage number': ph } : { 'Send by': 'Email' };
    }
    cartPost('/cart/add.js', { items: [item] }).then(function (r) {
      if (b) b.disabled = false;
      if (r && r.status) { if (b) { var o = b.innerHTML; b.textContent = r.description || 'Couldn’t add that'; setTimeout(function () { b.innerHTML = o; }, 2400); } return; }
      markAdded(id);
      return fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) { count(c.item_count); renderBag(c); if (b && b.classList.contains('btn')) bag(true); });
    }).catch(function () { if (b) b.disabled = false; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderBag(c) {
    var box = $('[data-bagitems]'); if (!box || !c) return; count(c.item_count);
    if (!c.items || !c.items.length) { box.innerHTML = '<p class="emp">Your bag is empty.</p>'; return; }
    var h = c.items.map(function (i) {
      var vt = i.variant_title, sub = vt ? (/exclusive/i.test(vt) ? esc(vt) + ' WAV' : esc(vt)) : 'Instant download';
      var img = i.image ? i.image.split('?')[0] + '?width=88&height=88&crop=center' : '';
      return '<div class="ci"><span class="pC">' + (img ? '<img src="' + img + '" alt="" width="44" height="44">' : '') + '</span><div>' + esc(i.product_title.replace(/^DashOTB /, '')) + '<span>' + sub + (i.quantity > 1 ? ' × ' + i.quantity : '') + '</span></div><div class="k-num">' + money(i.final_line_price) + '</div><button class="rm" type="button" data-rm="' + esc(i.key) + '" aria-label="Remove ' + esc(i.product_title) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg></button></div>';
    }).join('');
    var disc = c.total_discount > 0 ? '<div class="ci"><div>Discounts</div><div class="k-num">−' + money(c.total_discount) + '</div></div>' : '';
    h += '<div class="ci"><div><b>Subtotal</b></div><b class="k-num">' + money(c.items_subtotal_price) + '</b></div>' + disc + '<p class="note">Automatic discounts apply here and at checkout.</p><a class="btn" href="/checkout">Checkout<span class="pr">' + money(c.total_price) + '</span></a>';
    box.innerHTML = h;
  }
  var lastFocus = null;
  function bag(on) {
    var root = d.documentElement, dr = $('#dp-bag'); if (!dr) return;
    if (on) { lastFocus = d.activeElement; fetch('/cart.js').then(function (r) { return r.json(); }).then(renderBag); }
    root.classList.toggle('bag-open', on); dr.setAttribute('aria-hidden', !on);
    if (on) setTimeout(function () { var x = $('[data-bagx]', dr); x && x.focus(); }, 50); else if (lastFocus) lastFocus.focus();
  }
  if (window.dpCfg && dpCfg.count > 0) fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { (c.items || []).forEach(function (i) { markAdded(i.variant_id); }); });

  /* ---------- archive slide (desktop band; phone: native scroll-snap carousel + thumb strip) ---------- */
  $$('.dp-archive').forEach(function (sec) {
    var data = []; try { data = JSON.parse($('[data-ar]', sec).textContent); } catch (e) {}
    var by = {}; data.forEach(function (x) { by[x.n] = x; });
    var band = $('[data-band]', sec), cap = $('[data-arcap]', sec), big = $('[data-big]', sec), row2 = $('[data-row2]', sec), cimg = $('.pC img', cap), shown = null;
    var sl = $$('.band .sl', sec);
    if (sl.some(function (s) { return s.dataset.cat; })) {
      var byCat = function (a, b) { return a.dataset.cat.localeCompare(b.dataset.cat, undefined, { numeric: true }); };
      sl.sort(byCat).forEach(function (s) { band.appendChild(s); });
      if (big) $$('.bs', big).sort(function (a, b) { return byCat($('.sl[data-i="' + a.dataset.i + '"]', band), $('.sl[data-i="' + b.dataset.i + '"]', band)); }).forEach(function (s) { big.appendChild(s); });
      if (row2) $$('.sl', row2).sort(function (a, b) { return byCat($('.sl[data-i="' + a.dataset.i + '"]', band), $('.sl[data-i="' + b.dataset.i + '"]', band)); }).forEach(function (s) { row2.appendChild(s); });
    }
    // the caption is a player too: it walks the archive products that have a preview
    cap._pl = data.filter(function (x) { return x.au; }).map(function (x) { return { t: x.at || x.t, u: x.au, pk: x.apk, k: x.t, ku: x.u, a: x.th || '', v: String(x.v || ''), p: x.p || '', cp: x.cp || '', n: x.n }; });
    cap._i = 0; cap._ok = 1;
    cap._onidx = function (i) { show(cap._pl[i].n, 'player'); };
    function thumbInView(i) {
      var t = row2 && $('.sl[data-i="' + i + '"]', row2); if (!t) return;
      var l = t.offsetLeft - row2.offsetLeft, w = row2.clientWidth;
      if (l < row2.scrollLeft || l + 52 > row2.scrollLeft + w) row2.scrollTo({ left: l - w / 2 + 26, behavior: RM ? 'auto' : 'smooth' });
    }
    function show(i, from) {
      var x = by[i]; if (!x || shown == i) return; shown = i;
      $$('.sl', sec).forEach(function (s) { var on = s.dataset.i == i; s.classList.toggle('open', on); s.setAttribute('aria-pressed', on); });
      var bt = $('.bt', cap), a = $('[data-at]', cap), put = function () { a.href = x.u; a.innerHTML = '<b>' + esc(x.t) + '</b>'; $('[data-ad]', cap).textContent = x.c || ''; };
      // the caption slides out and the new one in; a swipe swaps at once and only animates in, so the caption never lags the snap
      if (bt.getAnimations) bt.getAnimations().forEach(function (an) { an.cancel(); });
      if (RM || from === 'init' || !bt.animate) put();
      else if (from === 'swipe') { put(); bt.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' }); }
      else bt.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px)' }], { duration: 130, easing: 'ease-in' }).onfinish = function () { put(); bt.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 300, easing: 'cubic-bezier(.2,.8,.2,1)' }); };
      var btn = $('[data-ab]', cap); btn.dataset.add = x.v; btn.disabled = !x.a; btn.innerHTML = x.p ? 'Add to bag<span class="pr">' + (x.cp ? '<s><span class="sr">Was </span>' + esc(x.cp) + '</s> ' : '') + esc(x.p) + '</span>' : 'Get it';
      var k = -1; for (var j = 0; j < cap._pl.length; j++) if (cap._pl[j].n == i) k = j;
      cap.classList.toggle('noau', k < 0);
      if (k >= 0) { setIndex(cap, k, true); if (cimg && x.th) cimg.src = x.th; } else { cap.dataset.src = ''; }
      sync();
      thumbInView(i);
      // phone: load the covers either side now, so the next swipe never lands on a blank slide
      var cs = big && big.offsetParent && $('.bs[data-i="' + i + '"]', big);
      if (cs) [cs, cs.previousElementSibling, cs.nextElementSibling, cs.nextElementSibling && cs.nextElementSibling.nextElementSibling].forEach(function (x) { var im = x && $('img', x); if (im) im.loading = 'eager'; });
      if (from !== 'swipe' && big) { var s = $('.bs[data-i="' + i + '"]', big); if (s && big.offsetParent) big.scrollTo({ left: s.offsetLeft - big.offsetLeft, behavior: from === 'init' || RM ? 'auto' : 'smooth' }); }
    }
    var o = $('.band .sl.open', sec); if (o) show(o.dataset.i, 'init');
    sec.addEventListener('click', function (e) { var s = e.target.closest('.band .sl,.row2 .sl'); if (s) show(s.dataset.i, 'tap'); });
    // the moment a cover snaps into place, the caption and the thumb strip follow (no debounce, no re-render)
    if (big && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) show(en.target.dataset.i, 'swipe'); }); }, { root: big, threshold: 0.6 });
      $$('.bs', big).forEach(function (s) { io.observe(s); });
    }
    if (band) {
      band.addEventListener('mouseover', function (e) { var s = e.target.closest('.sl'); $$('.sl.peek', band).forEach(function (p) { if (p !== s) p.classList.remove('peek'); }); if (s && !s.classList.contains('open')) { s.classList.add('peek'); band.classList.add('dim'); } });
      band.addEventListener('mouseleave', function () { $$('.sl.peek', band).forEach(function (p) { p.classList.remove('peek'); }); band.classList.remove('dim'); });
    }
  });

  /* ---------- shelf: kind chips and sorts ---------- */
  $$('[data-shelf]').forEach(function (g) {
    var sec = g.closest('section'), kind = '', by = 'i', none = $('[data-none]', sec);
    function apply() {
      var t = $$('.tA', g), n = 0;
      t.forEach(function (x) { var ok = !kind || (x.dataset.kind || '').toLowerCase() === kind.toLowerCase(); x.hidden = !ok; if (ok) n++; });
      t.sort(function (a, b) { if (by === 'bpm') return (+a.dataset.bpm) - (+b.dataset.bpm); if (by === 'key') return (a.dataset.key || 'zz').localeCompare(b.dataset.key || 'zz'); return (+a.dataset.i) - (+b.dataset.i); }).forEach(function (x) { g.appendChild(x); });
      if (none) none.hidden = n > 0;
    }
    sec.addEventListener('click', function (e) {
      var c = e.target.closest('[data-kind]'), s = e.target.closest('[data-sort]');
      if (c && c.tagName === 'BUTTON') { kind = c.dataset.kind; $$('.chips button', sec).forEach(function (b) { b.classList.toggle('on', b === c); b.setAttribute('aria-pressed', b === c); }); apply(); }
      if (s) { by = s.dataset.sort; $$('.sorts button', sec).forEach(function (b) { b.classList.toggle('on', b === s); b.setAttribute('aria-pressed', b === s); }); apply(); }
    });
  });

  /* ---------- sign-up forms: plain-words error ---------- */
  $$('form.dp-signup').forEach(function (f) {
    f.setAttribute('novalidate', '');
    f.addEventListener('submit', function (e) { var i = $('input[type=email]', f), m = $('[data-ferr]', f); if (i && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim())) { e.preventDefault(); if (m) m.hidden = false; i.focus(); } });
  });

  /* ---------- nav: backdrop once scrolled, phone menu sheet ---------- */
  var top = $('#dp-top'), sheet = $('#dp-menu'), mbtn = $('[data-mnu]');
  if (top) { var onS = function () { top.classList.toggle('scrolled', scrollY > 8); }; addEventListener('scroll', onS, { passive: true }); onS(); }
  function menu(on) {
    if (!sheet || !mbtn) return;
    if (on) { sheet.hidden = false; requestAnimationFrame(function () { sheet.classList.add('open'); }); }
    else { sheet.classList.remove('open'); setTimeout(function () { if (!sheet.classList.contains('open')) sheet.hidden = true; }, 220); }
    top.classList.toggle('mopen', on); d.documentElement.style.overflow = on ? 'hidden' : '';
    mbtn.setAttribute('aria-expanded', on); mbtn.textContent = on ? 'Close' : 'Menu';
  }
  phone.addEventListener && phone.addEventListener('change', function () { if (!phone.matches) menu(false); });

  /* ---------- keep the play bar clear of other fixed UI at the bottom (Shopify's preview bar, chat widgets) ---------- */
  var ro = window.ResizeObserver ? new ResizeObserver(function () { clearUI(); }) : null, seen = [];
  function clearUI() {
    var h = 0;
    Array.prototype.forEach.call(d.body.children, function (c) {
      if (c.classList.contains('dp-x') || c.id === 'dp-audio' || c.tagName === 'SCRIPT') return;
      var cs = getComputedStyle(c); if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      if (ro && seen.indexOf(c) < 0) { seen.push(c); ro.observe(c); }
      var r = c.getBoundingClientRect();
      if (r.height > 0 && r.height < 200 && r.width > innerWidth * 0.5 && r.bottom >= innerHeight - 2) h = Math.max(h, innerHeight - r.top);
    });
    d.documentElement.style.setProperty('--ui-b', Math.round(h) + 'px');
  }
  if (window.MutationObserver) new MutationObserver(clearUI).observe(d.body, { childList: true });
  addEventListener('resize', clearUI); addEventListener('load', clearUI); clearUI();

  /* ---------- entrance on scroll ---------- */
  if (!RM && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
    d.documentElement.classList.add('dp-anim');
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; var x = en.target; rio.unobserve(x); x.classList.add('vis');
        // hand the element back to its own hover transitions once it has arrived
        setTimeout(function () { x.removeAttribute('data-rv'); x.classList.remove('vis'); }, 1100 + (parseInt(x.style.getPropertyValue('--d'), 10) || 0));
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    $$('[data-rv]').forEach(function (x) {
      if (!x.style.getPropertyValue('--d')) { var sib = $$(':scope > [data-rv]', x.parentNode); x.style.setProperty('--d', (sib.indexOf(x) % 6) * 70 + 'ms'); }
      rio.observe(x);
    });
  }

  /* ---------- sign-up: Shopify marks every customer form on the page as posted; show "done" only on the one that was sent ---------- */
  $$('form.dp-signup').forEach(function (f) { f.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var o = $('[data-optin]', f), t = $('[data-tags]', f), yes = !!(o && o.checked);
    if (t) t.value = t.value.split(',').filter(function (x) { return x && x !== 'loops-list'; }).concat(yes ? ['loops-list'] : []).join(',');
    try { sessionStorage.setItem('dp-form', f.id); sessionStorage.setItem('dp-joined', yes ? '1' : '0'); } catch (x) {}
  }); });
  // 20 Oct: the thank-you page shows Monthly Loops and "you're on the list" only to people who ticked the box
  var joined; try { joined = sessionStorage.getItem('dp-joined') === '1'; } catch (x) {}
  $$('[data-joined-only]').forEach(function (el) { if (joined) el.hidden = false; });
  $$('[data-sent]').forEach(function (s) {
    var mine; try { mine = sessionStorage.getItem('dp-form') === s.dataset.sent; } catch (x) {}
    if (!mine) return;
    try { sessionStorage.removeItem('dp-form'); } catch (x) {}
    var f = s.closest('form'), u = f && $('[data-unsent]', f); s.hidden = false; if (u) u.hidden = true;
    var rt = s.dataset.rt || ''; if (rt && rt.split(/[?#]/)[0] !== location.pathname) setTimeout(function () { location.href = rt; }, 900);
  });

  /* ---------- go ---------- */
  $$('.dp-it').forEach(initItem);
  restore();
})();
